import { useQuery } from 'react-query';
import { httpService } from '../../../../services/http.service';
import { BASE_URL, USER } from '../../../../constants/endpoints';
import { useStore } from '../../../../store';

const { BASE } = USER;
const CONTROLLER_URL = BASE.replace('{version}', 'v1');

interface IProps {
  queryString: string;
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
  tableName: string;
}

export const useFetchInvoices = (
  {
    queryString,
    onSuccess,
    onError,
    tableName,
  } : IProps,
) => {
  const { currUser } = useStore.getState();
  const fetchInvoices = async () => {
    const { data } = await httpService.get(`${BASE_URL}/${CONTROLLER_URL}/${currUser()?.customerId}/invoices?${queryString}`);
    return data;
  };

  return useQuery(
    [tableName],
    async () => fetchInvoices(),
    {
      onSuccess: (data:any) => {
        if (onSuccess) onSuccess(data);
      },
      onError: (error: any) => {
        if (onError) onError(error);
      },
      enabled: false,
      retry: 1,
    },
  );
};
